// removed by extract-text-webpack-plugin
module.exports = {"department-scroll":"organisationChart__department-scroll___1txfv"};


//////////////////
// WEBPACK FOOTER
// ./src/views/Setup/OrganisationChart/organisationChart.less
// module id = 1408
// module chunks = 3